import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Link, Redirect } from 'react-router-dom'
import { Button} from '@material-ui/core'
import { Layout, Menu, Col, Row, } from 'antd';

import {login, logout }  from '../../../Auth/actions'

import '../Admin.css'

const { Content, Header } = Layout


export class UserConfirmationPage extends React.Component {

    componentDidMount() {
        localStorage.removeItem('access_token')
        const validationKey = this.props.match.params.key
        if (validationKey) {
            localStorage.setItem('validation', validationKey)
            this.props.logout('/confirm')
        }
    }

    render() {
        // const { validationFailure,  } = this.props
        const key = this.props.match.params.key
        if (!key && !localStorage.getItem('validation')) {
            return <Redirect to='/login' />
        }
        return (
			<React.Fragment>
				<Header className='header' style={{ lineHeight: '64px' }}>
						<Menu theme="dark"
							mode="horizontal" >
								<Menu.Item key='/admin' title='DICIDIO' className='logo menuItem'><Link to='/admin'>DICIDIO</Link></Menu.Item>
						</Menu>
				</Header>
                <Content >
                    <Row className="se-section">
                        <Col span ={6}>
                        </Col>
                        <Col span ={2}>
                        <img  src="../images/Dicidio_IconSet01_D.png" alt="Dicidio decisioning logo" style={{maxWidth:'100%', }}/>
                        </Col>

                        <Col span ={6}>
                        
                        <div className ="se-section-title se-centered" > 
                        Welcome to Dicidio, decisioning made easy.<br/>
                        </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col span = {6}/>
                        <Col span = {10}>
                        {/* Show when loading the page */}
                        <div style={{display: key ? '' : 'none' }} >
                            <div className ="se-section-body se-centered" > 
                            Now logging out any users that might have been logged in before, this will only take a second or two
                            <br/>
                            </div>
                            <br/>
                        </div>
                        {/* Show after the logout returns here */}
                        <div style={{display: !key && this.props.validationState==='initial' ? '' : 'none' }} >
                            <div className ="se-section-body se-centered" > 
                            You will be redirected to Auth0 to where you can either create a new account, or use your Google account to login. You will then automatically return to Dicidio. 
                            <br/>
                            </div>
                            <br/>
                            <div className ="se-section-body se-centered" > 
                                <Button  
                                    onClick={() => this.props.login(key)}>Login</Button>
                            <br/>
                            </div>
                        </div>
                        {/* Show on fail */}
                        <div style={{display: this.props.validationState==='failed' ? '' : 'none' }} >
                            <div className ="se-centered" > 
                                <h3>Oops</h3>
                            </div>
                            <div className ="se-section-body se-centered" > 
                            <br/>
                                <div>
                                Unfortunately we weren't able to activate your account. Please contact your organisation's Dicidio administrator who
                                can help you further.
                                </div>
                            </div>
                        </div>
                        </Col>

                    </Row>
                </Content>
			</React.Fragment>
        )
    }
}

UserConfirmationPage = connect(
    state => ({
        isAuthenticated: state.auth.isAuthenticated,
        validationState : state.auth.validationState || 'initial'
    }),
	dispatch => (
		bindActionCreators( {login, logout},  dispatch )
	)
)(UserConfirmationPage)


// WEBPACK FOOTER //
// ./src/App/Admin/User/UserConfirmationPage.jsx